/**
* Tiny-slider, apart gehouden van main.js.
*
* Goed voor ~24 kB gzip, en maar vijf templates roepen tns() aan: de vier
* campagnetypes en de "niet missen"-banner in Mijn A&O. Op alle andere
* pagina's werd hij wel gedownload en geparsed zonder ooit gebruikt te worden.
*
* Laden met {% js "/dist/js/slider.js" %} in de templates die hem nodig hebben.
* Craft plaatst zo'n bestand vóór de samengevoegde inline {% js %}-blokken, en
* <script type="module"> is sowieso uitgesteld, dus window.tns bestaat op het
* moment dat de init-code draait.
*/
import { tns } from 'tiny-slider/src/tiny-slider';

/**
* useLocalStorage: false omdat tiny-slider anders zijn feature-detectie
* (t3D, tADe, tnsApp, …) in localStorage cachet, zonder toestemming. Cookiebot
* rapporteert die keys als marketing-opslag. Default hier zodat de inline
* tns()-aanroepen in de templates het ook krijgen.
*/
window.tns = (options) => tns({ useLocalStorage: false, ...options });

/**
* Init voor de bodybuilder-slider. Die stond in main.js, maar hoort hier:
* .js-slider komt uit _components/bodybuilder/image/slider.twig en verschijnt
* dus alleen op pagina's waar een redacteur dat blok heeft toegevoegd. Welke
* dat zijn is niet statisch te bepalen, daarom registreert dat template zelf
* dit bestand.
*/
if (document.querySelector('.js-slider')) {
	window.tns({
		container: '.js-slider',
		items: 1,
		slideBy: 'page',
		nav: false,
		controls: true,
		autoplay: true,
		loop: true,
		autoplayButtonOutput: false
	});
}
